<template>
    <div class="tw-w-full tw-flex tw-justify-center">
        <q-card
            class="tw-p-4 tw-w-full tw-max-w-full md:tw-max-w-[280px] tw-flex tw-flex-col tw-justify-between tw-gap-4 tw-border tw-shadow-none"
        >
            <div>
                <q-skeleton height="180px" style="border-radius: 6px" />
                <div class="tw-grid tw-grid-cols-12 tw-gap-1 tw-my-2 tw-mx-4">
                    <template v-for="item in 4" :key="item">
                        <q-skeleton
                            class="tw-col-span-3 tw-aspect-square tw-rounded-[3px]"
                        />
                    </template>
                </div>
                <q-separator />
                <div>
                    <q-skeleton
                        type="text"
                        width="50%"
                        height="40px"
                        class="tw-rounded-[3px]"
                    />
                    <q-skeleton
                        type="text"
                        width="100%"
                        height="60px"
                        class="tw-rounded-[3px]"
                    />
                </div>
                <div>
                    <q-skeleton
                        type="text"
                        width="60%"
                        height="40px"
                        class="tw-rounded-[3px]"
                    />
                </div>

                <div class="tw-flex tw-gap-2 tw-w-[50%]">
                    <q-skeleton
                        type="text"
                        width="100%"
                        height="40px"
                        class="tw-rounded-[3px]"
                    />
                    <q-skeleton
                        type="text"
                        width="100%"
                        height="40px"
                        class="tw-rounded-[3px]"
                    />
                </div>
            </div>
            <div class="tw-flex tw-justify-between tw-items-center">
                <q-skeleton
                    type="QBtn"
                    width="30%"
                    height="25px"
                    class="tw-rounded-full"
                />
                <q-skeleton
                    type="QBtn"
                    width="30%"
                    height="25px"
                    class="tw-rounded-full"
                />
            </div>
        </q-card>
    </div>
</template>
